import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { api, errMsg } from "@/lib/api";

const MAX = 12;
const withFavs = (favorites) => (s) => ({ ...s, user: { ...s.user, favorites } });

export function useFavorites() {
  const { session, setSession } = useAuth();
  const favs = session.user.favorites || [];
  const toggle = async (to) => {
    const on = favs.includes(to);
    if (!on && favs.length >= MAX) { toast.error(`Você pode fixar até ${MAX} telas`); return; }
    const next = on ? favs.filter((x) => x !== to) : [...favs, to];
    setSession(withFavs(next));
    try {
      await api.put("/auth/me/favorites", { items: next });
    } catch (e) {
      setSession(withFavs(favs));
      toast.error(errMsg(e));
    }
  };
  return [favs, toggle];
}
